;
/*!
 * subitotexto.kludges.js
 */
SubitoTexto.kludges = {
	init: function () {
		var $ = jqPla,
			_this = SubitoTexto.kludges;


		// Fix the white background of the CTA on the home page (CSS just ain't doing it)
		_this.$homeCtaIdeeArticle = $( 'body.home' ).find( '.cta-idee-article' );

		if ( _this.$homeCtaIdeeArticle.length > 0 ) {
			_this.$homeFirstArticle = $( '.post-listings-container' ).find( '.entry' ).eq( 0 );


			var debounceHomeCtaPositioning = PLA.UTILS.debounce( function () {
				_this.adjustHomeCtaIdeeArticle();
			}, 250 );

			window.addEventListener( 'resize', debounceHomeCtaPositioning );

			_this.adjustHomeCtaIdeeArticle();

		}


		_this.$pointageTabs = $( '.jeux' ).find( '.radio-tabs' );

		if ( _this.$pointageTabs.length > 0 ) {
			_this.stickyPointageTabs();
		}


	},

	adjustHomeCtaIdeeArticle: function () {
		var $ = jqPla,
			_this = SubitoTexto.kludges.adjustHomeCtaIdeeArticle;

		// placing in natural position while we calculate
		SubitoTexto.kludges.$homeCtaIdeeArticle.css( {
			marginTop: 0
		} );


		if ( !PLA.UTILS.areWeMobile() ) {

			var articleTop = SubitoTexto.kludges.$homeFirstArticle.offset().top,
				articleHeight = SubitoTexto.kludges.$homeFirstArticle.outerHeight(),
				articleLinePosition = articleTop + ( articleHeight * 222 / 285 ), // the position is based on widget_post_listings.less
				ctaTop = SubitoTexto.kludges.$homeCtaIdeeArticle.offset().top,
				ctaPushUp = ctaTop - articleLinePosition;


			SubitoTexto.kludges.$homeCtaIdeeArticle.css( {
				marginTop: -ctaPushUp
			} );

			// console.log( '[SubitoTexto.kludges.adjustHomeCtaIdeeArticle] ',
			// 	'articleTop', articleTop,
			// 	'articleHeight', articleHeight,
			// 	'articleLinePosition', articleLinePosition,
			// 	'ctaTop', ctaTop,
			// 	'ctaPushUp',ctaPushUp
			// );

		}
	},


	stickyPointageTabs: function () {
		var $ = jqPla,
			_this = SubitoTexto.kludges.stickyPointageTabs;


		_this.$mainTabs = SubitoTexto.kludges.$pointageTabs.find( '.main-tab' );
		_this.$mainRadios = SubitoTexto.kludges.$pointageTabs.find( ' > .state' );


		_this.currentMode = 'desktop';

		var debounceStickyPointageTabs = PLA.UTILS.debounce( function () {


			if ( !PLA.UTILS.areWeMobile() && _this.currentMode == 'mobile' ) {

				_this.currentMode == 'desktop';

				if ( typeof  _this.$mainLabelClone != 'undefined' ) {
					_this.$mainLabelClone.remove();
				}

				if ( typeof  _this.$subLabelClone != 'undefined' ) {
					_this.$subLabelClone.remove();
				}

				return;
			} else if ( PLA.UTILS.areWeMobile() ) {


				_this.$visiblePanels = SubitoTexto.kludges.$pointageTabs.find( '.panel' ).filter( ':visible' );

				_this.$subRadios = _this.$visiblePanels.find( '.state' );
				_this.$subTabs = _this.$visiblePanels.find( '.tab' );


				var $activeMainRadio = _this.$mainRadios.filter( ':checked' ),
					activeMainId = $activeMainRadio.attr( 'id' ),
					$activeMainLabel = _this.$mainTabs.filter( '[for="' + activeMainId + '"]' ),
					mainLabelOffsetTop = $activeMainLabel.offset().top,

					$activeSubRadio = _this.$subRadios.filter( ':checked' ),
					activeSubId = $activeSubRadio.attr( 'id' ),
					$activeSubLabel = _this.$subTabs.filter( '[for="' + activeSubId + '"]' ),
					subLabelOffsetTop = $activeSubLabel.offset().top,

					windowScroll = $( window ).scrollTop();

				//console.log( $activeSubRadio, activeSubId, $activeSubLabel, subLabelOffsetTop, windowScroll );

				// Main Tabs
				if ( windowScroll > mainLabelOffsetTop ) {

					if ( typeof  _this.$mainLabelClone != 'undefined' ) {
						_this.$mainLabelClone.remove();
					}

					_this.$mainLabelClone = $activeMainLabel.clone().insertAfter( $activeMainLabel ).hide();

					_this.$mainLabelClone
						.addClass( 'fixed' )
						.css( {
							position: 'fixed',
							top     : 0
						} )
						.show();

				} else {
					if ( typeof  _this.$mainLabelClone != 'undefined' ) {
						_this.$mainLabelClone.remove();
					}
				}


				// Sub Tabs
				if ( windowScroll > subLabelOffsetTop ) {
					if ( typeof  _this.$subLabelClone != 'undefined' ) {
						_this.$subLabelClone.remove();
					}

					_this.$subLabelClone = $activeSubLabel.clone().insertAfter( $activeSubLabel ).hide();

					_this.$subLabelClone
						.addClass( 'fixed' )
						.css( {
							position: 'fixed',
							top     : $activeMainLabel.outerHeight()
						} )
						.show();

				} else {
					if ( typeof  _this.$subLabelClone != 'undefined' ) {
						_this.$subLabelClone.remove();
					}
				}


			}


		}, 250 );

		window.addEventListener( 'scroll', debounceStickyPointageTabs );
	
	}
};